import Navbar from '../components/Navbar';
import MobileHeader from '../components/MobileHeader';
import BackButton from '../components/BackButton';
import SwapWidget from '../components/SwapWidget';
import { useCryptoData } from '../hooks/useCryptoData';
import { TrendingUp, TrendingDown } from 'lucide-react';

const Swap = () => {
  const { cryptos, loading } = useCryptoData(50);
  return (
    <div className="min-h-screen" style={{ background: 'var(--bg-primary)' }}>
      <Navbar isDashboard={true} />
      <MobileHeader isDashboard={true} />

      <div className="pt-20 sm:pt-24 pb-20 sm:pb-12 px-3 sm:px-4 md:px-6">
        <div className="container mx-auto max-w-7xl">
          <BackButton label="Back" />
          <div className="mb-6 sm:mb-8">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2">Crypto <span className="gradient-text">Swap</span></h1>
            <p className="text-gray-400 text-sm sm:text-base md:text-lg">Instantly swap between cryptocurrencies at real-time market rates</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6">
            {/* Swap Widget */}
            <div className="lg:col-span-2">
              <SwapWidget />
            </div>

            {/* Market Prices */}
            <div className="lg:col-span-1">
              <div className="glow-card p-6 rounded-2xl sticky top-24">
                <h3 className="text-xl font-bold mb-4">Live Prices</h3>
                {loading ? (
                  <div className="text-center text-gray-400 py-4">Loading prices...</div>
                ) : (
                  <div className="space-y-3 max-h-[600px] overflow-y-auto">
                    {cryptos.slice(0, 20).map((crypto) => (
                    <div
                      key={crypto.id}
                      className="flex items-center justify-between p-3 bg-gray-900/50 rounded-xl hover:bg-gray-900/70 transition-colors"
                    >
                      <div className="flex items-center space-x-3">
                        <img src={crypto.image} alt={crypto.name} className="w-8 h-8 rounded-full" />
                        <div>
                          <p className="font-semibold text-sm">{crypto.symbol.toUpperCase()}</p>
                          <p className="text-xs text-gray-500">{crypto.name}</p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="font-semibold text-sm font-mono">
                          ${crypto.current_price.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                        </p>
                        <p
                          className={`text-xs flex items-center justify-end ${
                            crypto.price_change_percentage_24h >= 0 ? 'text-green-400' : 'text-red-400'
                          }`}
                        >
                          {crypto.price_change_percentage_24h >= 0 ? (
                            <TrendingUp className="h-3 w-3 mr-0.5" />
                          ) : (
                            <TrendingDown className="h-3 w-3 mr-0.5" />
                          )}
                          {crypto.price_change_percentage_24h >= 0 ? '+' : ''}
                          {crypto.price_change_percentage_24h.toFixed(2)}%
                        </p>
                      </div>
                    </div>
                    ))}
                  </div>
                )}

                {/* Swap Info */}
                <div className="mt-6 p-4 bg-purple-600/10 border border-purple-500/30 rounded-xl">
                  <h4 className="font-semibold text-sm mb-3">Why Swap with Phantom Trades?</h4>
                  <ul className="space-y-2 text-xs text-gray-400">
                    <li className="flex items-start">
                      <span className="text-purple-400 mr-2">•</span>
                      <span>Real-time market prices</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-400 mr-2">•</span>
                      <span>Low fees (0.1%)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-400 mr-2">•</span>
                      <span>Instant execution</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-purple-400 mr-2">•</span>
                      <span>No hidden charges</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Swap;
